import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/twitter-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM351.1 190.8c12.8-9.3 24-20.9 32.9-34-11.8 5.1-24.6 8.8-37.8 10.2 13.6-8.1 23.9-20.9 28.8-36.1-12.6 7.5-26.8 13-41.6 15.8-12-12.8-29-20.7-47.9-20.7-40 0-73.3 36.1-64 80.6-54.4-2.8-102.9-28.8-135.2-68.6-5.7 9.7-8.9 20.9-8.9 33.1v0.1c0 19.4 13.1 43.8 29.2 54.5-10.7-0.4-20.9-3.4-29.6-8.3v0.8c0 31.9 22.5 58.3 52.5 64.4-10.4 2.7-19.5 2.7-29.6 1.2 8.3 26 32.5 44.9 61.3 45.5-22.5 17.6-50.7 28-81.4 28-5.4 0-10.5-0.2-15.8-0.8 29 18.6 63.5 29.4 100.7 29.4 120.6 0 186.6-99.9 186.6-186.6 0-2.8 0-5.7-0.2-8.5z'
      }
    ]
  }
})
